import * as React from "react";
import MoveTrackerContainer from "./move-tracker-container";

interface IProps {
    reloadCounts: () => void;
    isOps: boolean,
    isCourier: boolean,
    chainId?: string,
    cluster?: string,
    position?: string
}

class MoveTracker extends React.Component<IProps, {}> {
    componentWillMount = () => {
        document.title = "NKR Admin: Move Tracker"
    }

    handleReloadCounts = () => {
        if (this.props.isCourier == false) {
            this.props.reloadCounts();
        }
    }

    render = () => {
        return (
            <div style={{ paddingTop: 0 }}>
                <MoveTrackerContainer
                    reloadCounts={this.handleReloadCounts}
                    isOps={this.props.isOps}
                    isCourier={this.props.isCourier}
                    chainId={this.props.chainId}
                    cluster={this.props.cluster}
                    position={this.props.position}
                />
            </div>
        );
    }
}

export default MoveTracker;